
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuButton from '../Button/Button.vue';
import PromoIcon from '../../../Icons/PromoIcon.vue';
import CheckPromoIcon from '../../../Icons/CheckPromoIcon.vue';
/**
- Change the circle clip background color with <b>.circle-mask</b> class
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralPromoCard',
  components: {
    EuCard,
    EuButton,
    PromoIcon,
    CheckPromoIcon
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'float'
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set icon color
     */
    iconColor: {
      type: String,
      default: '#ff6400'
    },
    /**
     * Set button label
     */
    buttonLabel: {
      type: String,
      default: ''
    },
    /**
     * Set button on disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Is promo applied or active state
     */
    isActive: {
      type: Boolean,
      default: false
    },
    /**
     * Custom icon for Promo Icon
     */
    customPromoIcon: {
      type: String,
      default: null
    }
  },
  methods: {
    handleCardClick(e: any) {
      /**
       * Method to click card
       * @event click-card
       * @type {function}
       */
      this.$emit('click-card', e);
    },
    handleClick(e: any) {
      /**
       * Method to click button
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    }
  }
});
